import React from "react";
const Carrier_Truck= (props) =>(<svg width={24} height={17} xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{"Carrier_Truck"}</title>
      <path
        d="M13.25.375a.75.75 0 0 1 .743.648l.007.102v1.5h3.75a.75.75 0 0 1 .484.177l.077.075 3 3.375a.75.75 0 0 1 .181.389l.008.109v6.375a.75.75 0 0 1-.648.743l-.102.007H20a3 3 0 0 1-6 0H8.75a3 3 0 0 1-6 0h-1.5a.75.75 0 0 1-.743-.648L.5 13.125v-12a.75.75 0 0 1 .648-.743L1.25.375h12Zm-7.5 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm11.25 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm.413-8.25H14v8.25h.401a2.999 2.999 0 0 1 5.198 0H20v-3.75h-2.627a.75.75 0 0 1-.102-1.493l.102-.007H20v-.09l-2.587-2.91ZM12.5 1.875H2v10.5h1.151a2.999 2.999 0 0 1 5.198 0H12.5v-10.5Z"
        fill="#B3D4F5"
        fillRule="evenodd"
      />
    </svg>
 )
//const Carrier_Truck=(props)=>{return(<div>Hello</div>)}
export default Carrier_Truck;
  